import React from "react"
import { graphql, StaticQuery, Link } from "gatsby"

import "../style/footer.css"

const Footer = () => {

    return (

        <footer className="relative px-2 mt-32 duration-500 bg-white dark:bg-BaseDarkHighlight">
            <div className="container mx-auto">
                <div className="custom-shape-divider-top-1601359248">
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
                    </svg>
                </div>
                <h3 className="pt-40 text-2xl font-bold tracking-tight text-center dark:text-BaseLight md:text-3xl md:text-left">Thank you for visiting</h3>
                <div className="flex justify-between hidden mt-4 md:flex">
                    <div className="flex items-center">
                        <div>
                            <img className="border border-gray-400 rounded-full sm:h-16 sm:w-16 md:h-16 md:w-16 lg:h-16 lg:w-16" src="/matt2.jpg" alt="me"/>
                        </div>
                        <div>
                            <p className="ml-2 font-bold tracking-tight dark:text-BaseLight md:text-2xl">You've been lovely <span role="img" aria-label="kiss emoji">💋</span></p>
                        </div>
                    </div>
                    <div>
                        <h3 className="mt-1 text-sm tracking-tight dark:text-gray-400 lg:text-xl lg:font-bold">Featured Projects</h3>
                        <ul className="mt-2 space-y-1">
                            <li className="text-xs lg:text-sm dark:text-gray-500">1. Brochure with Headless CMS and Gatsby</li>
                            <li className="text-xs lg:text-sm dark:text-gray-500">2. MERN Stack Twitter-Style App</li>
                            <li className="text-xs lg:text-sm dark:text-gray-500">3. GitHub Project Tracker</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="mt-1 text-sm tracking-tight dark:text-gray-400 lg:text-xl lg:font-bold">Latest Blog Posts</h3>
                        <StaticQuery query={footerQuery} render={(data) => (
                           <ol className="mt-2 space-y-1">
                                {data.allMarkdownRemark.edges.map(({node}) => (

                                        <li key={node.id} className="text-sm list-decimal list-inside dark:text-gray-500">
                                            <Link to={node.fields.slug}>
                                            {node.frontmatter.title}
                                            </Link>
                                        </li>

                                ))}
                            </ol>

                        )}/>
                    </div>
                </div>
                <div className="flex flex-col items-center justify-between mt-12 mb-2 md:flex-row lg:h-12">
                    <div>
                        <span className="text-xs tracking-tight lg:text-sm dark:text-gray-500 font-ibm">Matt Heslington</span>
                    </div>
                    <div>
                        <p className="text-xs tracking-tight lg:text-sm dark:text-gray-500 font-ibm">The site was built using React &#40;Gatsby&#41; and Tailwindcss</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

const footerQuery = graphql`
    query footerQuery {
        allMarkdownRemark(
            sort: {fields: [frontmatter___date], order: DESC}
            limit: 3
            filter:{frontmatter:{tags:{eq:"Blog"}}}
        ) {
            edges{
                node{
                    id
                    frontmatter{
                        title
                    }
                    fields{
                        slug
                    }
                }
            }
        }
    }
`

export default Footer